import { CommonModule } from '@angular/common';
import { ModalBaseModule } from 'Angular/features/components/modals/modal-base/modal-base.module';
import * as i0 from "@angular/core";
export class RegistrationToActiveModalModule {
}
RegistrationToActiveModalModule.ɵfac = function RegistrationToActiveModalModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || RegistrationToActiveModalModule)(); };
RegistrationToActiveModalModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: RegistrationToActiveModalModule });
RegistrationToActiveModalModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, ModalBaseModule] });
